import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import Header from "../components/header";
import SideBar from "../components/SideBar";
import { useEffect, useState } from "react";
import useAxios from "../hooks/useAxios";
import axiosInstance from "../apis/commonAPI";

// import {user, menu,SESSION_DATA} from "../constants"
// import { getDatabase, ref, onValue } from "firebase/database";

export default function ProtectedRoutes() {
   const { user, menu, SESSION_DATA } = useSelector((state) => state.user);
   const [userFetchData, errorUser, loadingUser, axiosFetchUser] = useAxios();


   const GET_USER_URL = user?.usertype === "expert"?`/expert/${user?._id}`:`/users/getuser/${user?._id}`;



  const [sidebarToggle, setSidebarToogle] = useState(false);
  const [frenchiseeId, setFrenchiseeId] = useState(null);
  const [userSideBarData, setUserSideBarData] = useState(null);
  // const firebaseDb = getDatabase();
  // const [firebaseData, setFirebaseData] = useState({});



  const handleSidebarToggle = (toggleSidebar) => {
    setSidebarToogle(toggleSidebar);
  };

  useEffect(() => {
    user?.parentsDetails?.map((frenchiseFetch,index) => {
      if(frenchiseFetch?.parentLabel === 22){
        setFrenchiseeId(frenchiseFetch?.parentId?._id);
      }
    })
  }, [user, SESSION_DATA]);

  const getUserData = (url) => {
    axiosFetchUser({
      axiosInstance: axiosInstance,
      url: url,
      method: "GET",
    });
  };

  useEffect(() =>{
    getUserData(GET_USER_URL);

  },[GET_USER_URL])
  useEffect(() =>{
    setUserSideBarData(userFetchData?.[0]);

  },[loadingUser, userFetchData])

  return user != null ? (
    <div className="wrapper">
      <Header
        handleSidebarToggle={handleSidebarToggle}
        sidebarStatus={sidebarToggle}
        userName={(userSideBarData?.usertype ==="expert"?userSideBarData?.expertName:userSideBarData?.username) ?? "No User"}
        userType={userSideBarData?.usertype ?? "No UserType"}
      />
     
      <main
        className={`main-section  mt-20 ${
          sidebarToggle ? "" : "hide-sidebar"
        }`}
      >
        <div className="main-sidebar">
          <SideBar menu={menu} userData = {userSideBarData}/>
        </div>

        <div className="main-inner" onClick = {() => handleSidebarToggle(false)}>
          <Outlet />
        </div>
      </main>
    </div>
  ) : (
    <Navigate to={"/login"} />
  );
}
